import { render, staticRenderFns } from "./DocumentBySupervisor.vue?vue&type=template&id=69678a34&scoped=true&"
import script from "./DocumentBySupervisor.vue?vue&type=script&lang=js&"
export * from "./DocumentBySupervisor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentBySupervisor.vue?vue&type=style&index=0&id=69678a34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69678a34",
  null
  
)

export default component.exports